import { style } from '@vanilla-extract/css';

export const container = style({
  overflow: 'hidden',
  display: 'block',
  width: '100%',
});

export const textCenter = style({
  textAlign: 'center',
});

export const logo = style({
  width: '56px',
  maxWidth: '56px',
  height: 'auto',
  display: 'inline-block',
  padding: '12px 0',
});

export const title = style({
  fontWeight: 600,
  margin: 0,
});

export const description = style({
  margin: 0,
});

export const button = style({
  textDecoration: 'none',
  display: 'inline-block',
});

export const subheader = style({
  margin: 0,
  fontWeight: 600,
});

export const featureList = style({
  padding: 0,
});

export const featureListItem = style({
  margin: 0,
});
